const addSlide3 = (pptx) => {
  const slide2 = pptx.addSlide();
  slide2.background = { color: '#c7effc' };

  slide2.addText(
    [
      {
        text: 'CREATION DE VOTRE COMPTE',
        options: {
          fontSize: 42,
          color: '696969',
          breakLine: true,
          bold: true,
        },
      },
    ],
    {
      x: 2,
      y: 1.8,
      w: 6,
      h: 2,
      align: 'center',
    },
  );
};

export default addSlide3;
